/**
 * @module components\ghModelView\propView\templates\textInput
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Base from "./../../base";

@Component
export default class TextInput extends Base {}
